import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Container,
  Dropdown,
  Accordion,
  Button,
  Form,
  Spinner,
} from "react-bootstrap";
import Icofont from "react-icofont";
import PageTitle from "./common/PageTitle";
import CardItem from "./common/CardItem";
import CategoriesCarousel from "./common/CategoriesCarousel";
import { Index } from "./Index";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { isOpened, liefershops } from "../utils";
import { Helmet } from "react-helmet";
import { getPartnerIdFromDomain } from "../partnerDomain";

export function List() {
  const location = useLocation();

  let title;

  const params = new URLSearchParams(location.search);
  const plz = params.get("plz");
  const ort = params.get("ort");

  const [cards, setCards] = useState([]);
  const [thresholds, setThresholds] = useState([10, 15, 20, 30, 50]);

  const [price, setPrice] = useState(0);
  const [openState, setOpenState] = useState(false);

  const [specialty, setSpeciality] = useState("");
  const prevSpecialty = useRef("");

  const [loadingPanel, setLoadingPanel] = useState((
    <Button variant="primary" type="button" disabled="">
      <Spinner animation="grow" size="sm" className="mr-1" />
      Loading...
    </Button>
  ))

  const getCards = (price, setCards, plz, ort, time, specialty) => {
    fetch(liefershops(`api/v1/partner/?zip=${plz}`))
      .then((response) => response.json())
      .then((elements) => {
        const cardElements = [];

        // Build dynamic thresholds from actual mindestbestellwert values
        const allMinValues = new Set();
        elements.forEach((el) => {
          const foundZip = (el.zip_codes || []).find(item => item.postleitzahl === plz);
          if (foundZip) allMinValues.add(Math.ceil(parseFloat(foundZip.mindestbestellwert)));
        });
        const dynamicThresholds = [...allMinValues].sort((a, b) => a - b).filter(v => v > 0);
        if (dynamicThresholds.length > 0) setThresholds(dynamicThresholds);

        elements.forEach((element) => {
          const foundZip = (element.zip_codes || []).find(item => item.postleitzahl === plz);
          if (!foundZip) return;

          const elementPrice = parseFloat(foundZip.mindestbestellwert);

          if (price !== 0 && price < elementPrice)
            return;

          const state = isOpened(element);

          const rabatt = element.rabatt || 0;
          const rabattFest = parseFloat(element.rabatt_fest) || 0;
          const rabattFestAb = parseFloat(element.rabatt_fest_ab) || 0;

          let offerText = "";
          let offerTextRabattFestAb = "";

          if (rabatt !== 0) {
            offerText += `${Math.abs(rabatt)}% `;
          }

          /*  if (rabattFestAb !== 0) {
             if (offerText.length !== "") {
               offerText.concat(offerText, "\n");
             }

             offerText += `Rabatt ab ${Math.abs(rabattFestAb)} € : ${Math.abs(rabattFest)}%`;
           }
    */

          if (rabattFest !== 0) {
            offerTextRabattFestAb = ` ab ${Math.abs(rabattFestAb)} € : ${Math.abs(rabattFest)}%`;
          }


          if ((!time || state) && element.is_active) {
            if (specialty === "" || element.specialties.indexOf(specialty) !== -1) {
              const component = (
                <Col md={4} sm={6} className="mb-4 pb-2">
                  <CardItem
                    title={element.name}
                    /* subTitle="North Indian • American • Pure veg" */
                    imageAlt={`Partner Restaurant ${element.name}`}
                    image={element.background}
                    imageClass="w-100 h-100 item-img cover position-absolute"
                    /* imageClass="img-fluid item-img" */
                    linkUrl={element.slug && plz ? `/${element.slug}/${plz}` : `detail?id=${element.id}`}
                    // offerText="10 %, Rabatt ab 50.00 € : 5.00 %"
                    offerText={offerText}
                    offerTextRabattFestAb={offerTextRabattFestAb}
                    /* time="" */
                    price={elementPrice}
                    showPromoted={element.logo}
                    /* showPromoted={true} */
                    promotedVariant="dark"
                    favIcoIconColor="text-danger"
                  /* rating="3.1 (300+)" */
                  />
                </Col>
              );

              cardElements.push(component);
            }
          }

        });

        setCards(cardElements);

        setLoadingPanel(null);
      });
  }

  useEffect(() => {
    getCards(0, setCards, plz, ort, false, specialty);
  }, [plz, ort]);


  const handleMinCostClick = (newPrice) => () => {
    setPrice(newPrice);

    getCards(newPrice, setCards, plz, ort, openState, specialty);
  }

  const handleOpenPartners = (e) => {
    setOpenState(e.target.checked);


    getCards(price, setCards, plz, ort, e.target.checked, specialty);
  }

  const handleSpecialityChange = (e) => {
    if (specialty === e.props.title) {
      setSpeciality("")
    } else {
      setSpeciality(e.props.title);
    }

  }

  useEffect(() => {
    if (prevSpecialty.current !== specialty) {
      getCards(price, setCards, plz, ort, openState, specialty);
      prevSpecialty.current = specialty;
    }

  }, [specialty]);

  const partnerId = getPartnerIdFromDomain();
  if (partnerId && plz) {
    return <Redirect to={`/detail?id=${partnerId}`} />
  }

  if (plz === null && ort === null) {
    return <Redirect to={Index} />
  }

  return (
    <>
    <Helmet>
      <title>Bestellen Sie leckeres Essen online mit Liefershops.de</title>
      <meta name="description" content="Bestellen Sie köstliche Gerichte aus den besten Restaurants in Ihrer Nähe in Berlin. Entdecken Sie Angebote in Ihrer Nähe mit Liefershops.de" />
      <meta name="keywords" content="Essen bestellen, online Bestellservice, Restaurant Lieferdienst in Berlin, schnelle Lieferung" />
      <meta property="og:title" content="Bestellen Sie Essen online - schnell und lecker mit Liefershops.de in Berlin" />
      <meta property="og:description" content="Entdecken Sie die besten Restaurants und bestellen Sie Ihr Lieblingsessen bequem mit Liefershops.de in Berlin" />
      <meta property="og:type" content="website" />
      <meta name="robots" content="index, follow" />
    </Helmet>
      <PageTitle
        title="Angebote in Ihrer Nähe"
        subTitle="Entdecken Sie Restaurants, die Ihnen gefallen könnten"
      />
      <section className="section pt-5 pb-5 products-listing">
        <Container>
          <h4 className="font-weight-bold mt-0 mb-3">Alle Spezialitäten</h4>
          <CategoriesCarousel
            onSpecialityChange={handleSpecialityChange}
          />
          <Row className="d-none-m">
            <Col md={12}>
              {/* <Dropdown className="float-right">
                <Dropdown.Toggle variant="outline-info">
                  Sort by: <span className="text-theme">Distance</span>{" "}
                  &nbsp;&nbsp;
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu-right shadow-sm border-0">
                  <Dropdown.Item href="#/distance">Distance</Dropdown.Item>
                  <Dropdown.Item href="#/no-of-coupons">
                    No Of Offers
                  </Dropdown.Item>
                  <Dropdown.Item href="#/rating">Rating</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              <h4 className="font-weight-bold mt-0 mb-3">
                Angebote
              </h4>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <div className="filters shadow-sm rounded bg-white">
                <div className="filters-header border-bottom pl-4 pr-4 pt-3 pb-3">
                  <h5 className="m-0">Filtern nach</h5>
                </div>

                {/* <div className="filters-body">
                  <Accordion defaultActiveKey="0">
                    <div className="filters-card border-bottom p-4">
                      <div className="filters-card-header" id="headingOne">
                        <h6 className="mb-0">
                          <Accordion.Toggle
                            as={Button}
                            size="block"
                            variant="link"
                            className="text-left d-flex align-items-center p-0"
                            eventKey="0"
                          >
                            Location{" "}
                            <Icofont icon="arrow-down" className="ml-auto" />
                          </Accordion.Toggle>
                        </h6>
                      </div>
                      <Accordion.Collapse eventKey="0">
                        <div className="filters-card-body card-shop-filters">
                          <Form.Check
                            custom
                            type="checkbox"
                            defaultChecked={true}
                            id="custom-cb1"
                            label={
                              <React.Fragment>
                                Ludhiana Junction{" "}
                                <small className="text-black-50">230</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb2"
                            label={
                              <React.Fragment>
                                Model Town{" "}
                                <small className="text-black-50">95</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb3"
                            label={
                              <React.Fragment>
                                Civil Lines{" "}
                                <small className="text-black-50">35</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb4"
                            label={
                              <React.Fragment>
                                Dugri{" "}
                                <small className="text-black-50">46</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb5"
                            label={
                              <React.Fragment>
                                PAU{" "}
                                <small className="text-black-50">20</small>
                              </React.Fragment>
                            }
                          />
                          <div className="mt-2">
                            <Link to="#" className="link">
                              See all
                            </Link>
                          </div>
                        </div>
                      </Accordion.Collapse>
                    </div>
                    <div className="filters-card border-bottom p-4">
                      <div className="filters-card-header" id="headingTwo">
                        <h6 className="mb-0">
                          <Accordion.Toggle
                            as={Button}
                            size="block"
                            variant="link"
                            className="text-left d-flex align-items-center p-0"
                            eventKey="1"
                          >
                            All cuisines{" "}
                            <Icofont icon="arrow-down" className="ml-auto" />
                          </Accordion.Toggle>
                        </h6>
                      </div>

                      <Accordion.Collapse eventKey="1">
                        <div className="filters-card-body card-shop-filters">
                          <form className="filters-search mb-3">
                            <Form.Group>
                              <Icofont icon="search" />
                              <Form.Control
                                type="text"
                                placeholder="Start typing to search..."
                              />
                            </Form.Group>
                          </form>
                          <Form.Check
                            custom
                            type="checkbox"
                            defaultChecked={true}
                            id="custom-cb6"
                            label={
                              <React.Fragment>
                                American{" "}
                                <small className="text-black-50">156</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb7"
                            label={
                              <React.Fragment>
                                Pizza{" "}
                                <small className="text-black-50">120</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb8"
                            label={
                              <React.Fragment>
                                Healthy{" "}
                                <small className="text-black-50">130</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb9"
                            label={
                              <React.Fragment>
                                Vegetarian{" "}
                                <small className="text-black-50">120</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb10"
                            label={
                              <React.Fragment>
                                Chinese{" "}
                                <small className="text-black-50">111</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb11"
                            label={
                              <React.Fragment>
                                Hamburgers{" "}
                                <small className="text-black-50">95</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb12"
                            label={
                              <React.Fragment>
                                Dessert{" "}
                                <small className="text-black-50">50</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb13"
                            label={
                              <React.Fragment>
                                Chicken{" "}
                                <small className="text-black-50">32</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb14"
                            label={
                              <React.Fragment>
                                Indian{" "}
                                <small className="text-black-50">156</small>
                              </React.Fragment>
                            }
                          />
                          <div className="mt-2">
                            <Link to="#" className="link">
                              See all
                            </Link>
                          </div>
                        </div>
                      </Accordion.Collapse>
                    </div>
                    <div className="filters-card border-bottom p-4">
                      <div className="filters-card-header" id="headingOne">
                        <h6 className="mb-0">
                          <Accordion.Toggle
                            as={Button}
                            size="block"
                            variant="link"
                            className="text-left d-flex align-items-center p-0"
                            eventKey="2"
                          >
                            Feature{" "}
                            <Icofont icon="arrow-down" className="ml-auto" />
                          </Accordion.Toggle>
                        </h6>
                      </div>
                      <Accordion.Collapse eventKey="2">
                        <div className="filters-card-body card-shop-filters">
                          <Form.Check
                            custom
                            type="checkbox"
                            defaultChecked={true}
                            id="custom-cb15"
                            label={
                              <React.Fragment>
                                Free Delivery{" "}
                                <small className="text-black-50">156</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb16"
                            label={
                              <React.Fragment>
                                Coupons{" "}
                                <small className="text-black-50">120</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb17"
                            label={
                              <React.Fragment>
                                Open Now [1:31am]{" "}
                                <small className="text-black-50">85</small>
                              </React.Fragment>
                            }
                          />
                        </div>
                      </Accordion.Collapse>
                    </div>
                    <div className="filters-card border-bottom p-4">
                      <div className="filters-card-header" id="headingOne">
                        <h6 className="mb-0">
                          <Accordion.Toggle
                            as={Button}
                            size="block"
                            variant="link"
                            className="text-left d-flex align-items-center p-0"
                            eventKey="3"
                          >
                            Delivery time{" "}
                            <Icofont icon="arrow-down" className="ml-auto" />
                          </Accordion.Toggle>
                        </h6>
                      </div>
                      <Accordion.Collapse eventKey="3">
                        <div className="filters-card-body card-shop-filters">
                          <Form.Check
                            custom
                            type="checkbox"
                            defaultChecked={true}
                            id="custom-cb18"
                            label="Any Time"
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb19"
                            label="25 min"
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb20"
                            label="30 min"
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb21"
                            label="40 min"
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb22"
                            label="45 min"
                          />
                          <div className="mt-2">
                            <Link to="#" className="link">
                              See all
                            </Link>
                          </div>
                        </div>
                      </Accordion.Collapse>
                    </div>
                    <div className="filters-card border-bottom p-4">
                      <div className="filters-card-header" id="headingOne">
                        <h6 className="mb-0">
                          <Accordion.Toggle
                            as={Button}
                            size="block"
                            variant="link"
                            className="text-left d-flex align-items-center p-0"
                            eventKey="4"
                          >
                            Category{" "}
                            <Icofont icon="arrow-down" className="ml-auto" />
                          </Accordion.Toggle>
                        </h6>
                      </div>
                      <Accordion.Collapse eventKey="4">
                        <div className="filters-card-body card-shop-filters">
                          <Form.Check
                            custom
                            type="checkbox"
                            defaultChecked={true}
                            id="custom-cb23"
                            label={
                              <React.Fragment>
                                Delivery{" "}
                                <small className="text-black-50">156</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb24"
                            label={
                              <React.Fragment>
                                Dine-out{" "}
                                <small className="text-black-50">120</small>
                              </React.Fragment>
                            }
                          />

                          <Form.Check
                            custom
                            type="checkbox"
                            id="custom-cb25"
                            label={
                              <React.Fragment>
                                Cafés
                                <small className="text-black-50">85</small>
                              </React.Fragment>
                            }
                          />
                        </div>
                      </Accordion.Collapse>
                    </div>
                  </Accordion>
                </div> */}
              </div>

              <div className="filters pt-2">
                <div className="filters-body rounded shadow-sm bg-white">
                  <div className="filters-body">
                    <div className="p-4">
                      <Form>
                        <Form.Check
                          custom
                          type="switch"
                          id="custom-switch"
                          label="Jetzt geöffnet" // is open
                          onChange={handleOpenPartners}
                        />
                      </Form>
                    </div>

                  </div>
                </div>
              </div>

              <div className="filters pt-2">
                <div className="filters-body rounded shadow-sm bg-white">
                  <div className="filters-card p-4">
                    <div>
                      <h6>Mindestbestellwert</h6>
                      <div className="filters-card-body card-shop-filters pt-0">
                        <Form.Check
                          custom
                          type="radio"
                          name="partner"
                          id="custom-cb26"
                          label="Alle anzeigen"
                          defaultChecked={true}
                          onClick={handleMinCostClick(0)}
                        />
                        {thresholds.map((threshold, idx) => (
                          <Form.Check
                            key={threshold}
                            custom
                            type="radio"
                            name="partner"
                            id={`custom-cb${27 + idx}`}
                            label={`Bis ${threshold},00 €`}
                            onClick={handleMinCostClick(threshold)}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={9}>
              <Row>
                {cards}
                <Col md={12} className="text-center load-more">
                  {loadingPanel}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default List;